"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html, Image } from "@custom/schema";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { createRef, useEffect, useRef, useState } from "react";
export default function Slideshow(props) {
    var _props_startButtonSecondary, _props_endButtonSecondary;
    var _useState = _sliced_to_array(useState(false), 2), showSlider = _useState[0], setShowSlider = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), currentSlide = _useState1[0], setCurrentSlide = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), hideOverlay = _useState2[0], setHideOverlay = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), shouldAutoplay = _useState3[0], setShouldAutoplay = _useState3[1];
    var slideshowSlide = props.slideshowSlide;
    var handleShowSlider = function() {
        var _slideshowSlide_currentSlide;
        setHideOverlay(false);
        setTimeout(function() {
            setHideOverlay(true);
        }, 100);
        if ((_slideshowSlide_currentSlide = slideshowSlide[currentSlide]) === null || _slideshowSlide_currentSlide === void 0 ? void 0 : _slideshowSlide_currentSlide.videoUrl) {
            setShouldAutoplay(true);
        }
        setShowSlider(true);
    };
    var videoRefs = useRef([]);
    var _videoRefs_current_index;
    videoRefs.current = slideshowSlide.map(function(_, index) {
        return (_videoRefs_current_index = videoRefs.current[index]) !== null && _videoRefs_current_index !== void 0 ? _videoRefs_current_index : /*#__PURE__*/ createRef();
    });
    useEffect(function() {
        var currentVideoRef = videoRefs.current[currentSlide];
        if (currentVideoRef && currentVideoRef.current && showSlider) {
            var _slideshowSlide_currentSlide;
            var currentVideo = currentVideoRef.current;
            if ((_slideshowSlide_currentSlide = slideshowSlide[currentSlide]) === null || _slideshowSlide_currentSlide === void 0 ? void 0 : _slideshowSlide_currentSlide.videoUrl) {
                currentVideo.currentTime = 0; // Reset the video to the start
                currentVideo.play().catch(function(error) {
                    console.error("Error trying to play the video: ", error);
                });
            }
        }
    }, [
        currentSlide,
        slideshowSlide,
        showSlider
    ]);
    var handleNextSlide = function() {
        setCurrentSlide(function(prev) {
            return (prev + 1) % slideshowSlide.length;
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 relative pb-16"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative pt-[56.25%] w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("absolute top-0 left-0 aspect-w-12 aspect-h-6 w-full max-w-full h-full transition-all")
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx('flex justify-center before:content-[""] before:transition-opacity before:block before:w-full before:h-full before:position before:top-0 before:left-0 before:bg-white before:opacity-70', {
            "before:z-0": hideOverlay,
            "before:z-20": !hideOverlay,
            "before:opacity-0": showSlider,
            "before:!z-20 before:!opacity-70": currentSlide === props.slideshowSlide.length - 1
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute insex-x-0 top-1/2 -translate-y-1/2 mx-auto z-20"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col max-[767px]:items-center md:flex-row gap-4"
    }, /*#__PURE__*/ React.createElement("button", {
        id: "slideshow-1",
        className: clsx("button-primary transition-all animate-box-shadow-toggle py-2.5 flex items-center gap-x-2 bg-yellow-500 hover:bg-yellow-600 rounded-3xl text-lg xl:text-xl font-normal", {
            hidden: showSlider
        }),
        onClick: function() {
            handleShowSlider();
        }
    }, props.startButtonText, /*#__PURE__*/ React.createElement(ArrowRightIcon, {
        className: "w-6 h-6 animate-arrow-bounce"
    })), ((_props_startButtonSecondary = props.startButtonSecondary) === null || _props_startButtonSecondary === void 0 ? void 0 : _props_startButtonSecondary.label) ? /*#__PURE__*/ React.createElement("a", {
        href: props.startButtonSecondary.target,
        target: props.startButtonSecondaryTargetBlank ? "_blank" : "_self",
        rel: props.startButtonSecondaryTargetBlank ? "noopener noreferrer" : undefined,
        id: "slideshow-1a",
        className: clsx("button-primary transition-all shadow-[0_0_15px_-1px_rgba(0,0,0,0.15)] py-2.5 flex items-center gap-x-2 bg-white hover:bg-black hover:text-white rounded-3xl text-lg xl:text-xl font-normal", {
            hidden: showSlider
        })
    }, props.startButtonSecondary.label, /*#__PURE__*/ React.createElement(ArrowRightIcon, {
        className: "w-6 h-6"
    })) : null)))), /*#__PURE__*/ React.createElement("div", {
        className: "overflow-hidden"
    }, /*#__PURE__*/ React.createElement(AnimatePresence, null, slideshowSlide.map(function(slide, index) {
        return /*#__PURE__*/ React.createElement(motion.div, {
            key: index,
            initial: {
                opacity: 0
            },
            animate: {
                opacity: index === currentSlide ? 1 : 0
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 0.5
            },
            className: "absolute inset-0 flex-1 min-w-full flex items-stretch border border-gray-500",
            style: {
                visibility: index === currentSlide ? "visible" : "hidden"
            }
        }, slide.image && /*#__PURE__*/ React.createElement("div", {
            className: "aspect-w-12 aspect-h-6 w-full max-w-full"
        }, /*#__PURE__*/ React.createElement(Image, {
            className: "object-cover w-full h-full",
            source: slide.image.source,
            alt: slide.image.alt
        })), slide.videoUrl && /*#__PURE__*/ React.createElement("div", {
            className: "aspect-w-12 aspect-h-6 w-full max-w-full"
        }, /*#__PURE__*/ React.createElement("video", {
            ref: videoRefs.current[index],
            className: "object-cover w-full h-full",
            autoPlay: shouldAutoplay && index === currentSlide,
            muted: true,
            preload: "auto",
            playsInline: true
        }, /*#__PURE__*/ React.createElement("source", {
            src: slide.videoUrl,
            type: "video/mp4"
        }), "Your browser does not support the video tag.")));
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: clsx("max-w-xl z-10 pt-3.5 transition-all pb-5 px-4 md:px-5 shadow-[0_2px_10px_1px_rgba(0,0,0,0.15)] rounded-sm border border-gray-500 md:absolute bg-white", {
            "opacity-100": showSlider,
            "opacity-0": !showSlider,
            "inset-x-0 mx-auto md:top-1/2 md:-translate-y-1/2 z-30": currentSlide === props.slideshowSlide.length - 1,
            "-bottom-10 left-10": currentSlide !== props.slideshowSlide.length - 1
        })
    }, props.slideshowSlide.map(function(slide, index) {
        /*#__PURE__*/ return React.createElement(motion.div, {
            key: index,
            style: {
                display: currentSlide === index ? "block" : "none"
            },
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 0.5
            }
        }, (slide === null || slide === void 0 ? void 0 : slide.heading) ? /*#__PURE__*/ React.createElement("h3", {
            className: "text-lg md:text-xl font-semibold my-2 md:mb-3"
        }, slide === null || slide === void 0 ? void 0 : slide.heading) : null, (slide === null || slide === void 0 ? void 0 : slide.text) ? /*#__PURE__*/ React.createElement("div", {
            className: "lg:text-lg"
        }, /*#__PURE__*/ React.createElement(Html, {
            markup: slide.text
        })) : null);
    }), props.slideshowSlide.length > 1 ? /*#__PURE__*/ React.createElement("div", {
        className: "flex md:inline-flex items-baseline max-[767px]:justify-between px-0 gap-x-3 md:gap-x-6 mt-8 static"
    }, /*#__PURE__*/ React.createElement("button", {
        id: "slideshow-back-".concat(currentSlide + 2),
        className: clsx('disabled:opacity-30 disabled:cursor-not-allowed rounded-2xl text-xs focus focus-visible:outline-black transition-all hover:bg-white py-2 px-4 bg-arrow flex flex-row-reverse gap-x-2.5 after:content-[""] after:w-4 after:h-4 after:block after:rotate-180', {
            "after:w-4 after:h-4 rounded-full border border-gray-500 items-center px-3 py-3.5": currentSlide === props.slideshowSlide.length - 1
        }),
        onClick: function() {
            return setCurrentSlide(currentSlide - 1);
        },
        disabled: currentSlide === 0
    }, currentSlide === props.slideshowSlide.length - 1 ? "" : "Back"), currentSlide === props.slideshowSlide.length - 1 ? /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col max-[767px]:items-end sm:flex-row gap-x-4 items-center"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "".concat(props.downloadUrl),
        id: "slideshow-".concat(currentSlide + 2),
        className: "animate-box-shadow-toggle flex items-center rounded-3xl text-[15px] md:text-lg bg-yellow-500 hover:bg-gray-600 hover:text-white transition-all py-2 px-4 md:px-9"
    }, props.endButtonPrimaryText, /*#__PURE__*/ React.createElement(ArrowRightIcon, {
        className: "w-6 h-6 animate-arrow-bounce ml-2"
    })), ((_props_endButtonSecondary = props.endButtonSecondary) === null || _props_endButtonSecondary === void 0 ? void 0 : _props_endButtonSecondary.label) ? /*#__PURE__*/ React.createElement("a", {
        href: props.endButtonSecondary.target,
        target: props.endButtonSecondaryTargetBlank ? "_blank" : "_self",
        rel: props.endButtonSecondaryTargetBlank ? "noopener noreferrer" : undefined,
        id: "slideshow-1a",
        className: "button-primary mt-4 sm:mt-0 shadow-[0_0_15px_-1px_rgba(0,0,0,0.15)] transition-all py-2 px-4 md:px-9 inline-flex items-center gap-x-2 bg-white hover:bg-black hover:text-white rounded-3xl text-[15px] md:text-lg font-normal"
    }, props.endButtonSecondary.label, /*#__PURE__*/ React.createElement(ArrowRightIcon, {
        className: "w-6 h-6"
    })) : null) : /*#__PURE__*/ React.createElement("button", {
        id: "slideshow-".concat(currentSlide + 2),
        className: "disabled:opacity-30 disabled:cursor-not-allowed text-xs rounded-2xl focus focus-visible:outline-black bg-yellow-500 hover:bg-gray-600 hover:text-white transition-all py-2 px-9",
        onClick: handleNextSlide
    }, "Next")) : null))));
}
